import { render, staticRenderFns } from "./SurgeryPatientHistoryAccounting.vue?vue&type=template&id=c7b6ae08&scoped=true"
import script from "./SurgeryPatientHistoryAccounting.vue?vue&type=script&lang=js"
export * from "./SurgeryPatientHistoryAccounting.vue?vue&type=script&lang=js"
import style0 from "./SurgeryPatientHistoryAccounting.vue?vue&type=style&index=0&id=c7b6ae08&prod&scoped=true&lang=css"
import style1 from "./SurgeryPatientHistoryAccounting.vue?vue&type=style&index=1&id=c7b6ae08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b6ae08",
  null
  
)

export default component.exports